import { Review } from '@prisma/client';
import axios from 'axios';

export async function createReview(data: Omit<Review, 'id' | 'createdAt'>) {
  const response = await axios.post('/api/review', data);
  return response.data;
}

export async function updateReview(id: string, data: Partial<Review>) {
  const response = await axios.patch(`/api/review/${id}`, data);
  return response.data;
}

export async function deleteReview(id: string) {
  const response = await axios.delete(`/api/review/${id}`);
  return response.data;
}
